import { useContext, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { Page } from '../../components'
import { TimeClockUserDetail } from '../../components/TimeClock/TimeClockUserDetail'
import { AuthContext } from '../../providers'
import { GetUsersWithPermissionActEnum } from '../../sdk'

export default function TimeClockUserPage() {
  const { id } = useParams()
  const { currentUser } = useContext(AuthContext)
  const hasAccess = useMemo(
    () =>
      !!currentUser?.permissions.has(
        GetUsersWithPermissionActEnum.ManageTimeClock
      ) || id === currentUser?.id!,
    [currentUser?.id, currentUser?.permissions, id]
  )

  return (
    <Page title="Time Clock">
      {hasAccess ? <TimeClockUserDetail /> : <></>}
    </Page>
  )
}
